<div
  id="drop-area"
  class="drag-zone"
  (dragenter)="dragenter($event)"
  (dragover)="dragover($event)"
  (drop)="drop($event)">
  <h1 class="mat-h4">{{ dragMessage }}</h1>
  <span *ngIf="!canDropFolder"> Folder Drop Not Supported by Browser </span>
</div>
